import useCustomerData from "../hooks/useCustomerData";
import { useLegacyDownloadAppCookieMigration } from "../hooks/promoMaterial/useLegacyDownloadAppCookieMigration";
import { useEntityImageLookup } from "../hooks/useEntityImageLookup";
import { useAutoApplyOffer } from "../hooks/loyalty/useAutoApplyOffer";
import { useLoyaltyTierTheme } from "../hooks/loyalty/useLoyaltyTierTheme";
import useFranchiseData from "../hooks/useFranchiseData";
import useLinkOffers from "../hooks/useLinkOffers";
import { useLoyaltyDataRefetch } from "../hooks/useLoyaltyDataRefetch";
import { useMetaClickIds } from "../hooks/useMetaClickIds";
import { useMetaSessionContext } from "../hooks/useMetaSessionContext";
import { useReleaseAbandonedPayment } from "../hooks/useReleaseAbandonedPayment";
import useRestaurantData from "../hooks/useRestaurantData";

// Memoized by parent BackgroundManager
const BackgroundHooks = () => {
  useCustomerData();
  useRestaurantData();
  useEntityImageLookup();
  useFranchiseData();
  useLinkOffers();
  useAutoApplyOffer();
  useLoyaltyDataRefetch();
  useLoyaltyTierTheme();
  useMetaClickIds();
  useMetaSessionContext();
  useReleaseAbandonedPayment();
  useLegacyDownloadAppCookieMigration();

  return null;
};

export default BackgroundHooks;
